import React from 'react';
import { Box } from '../Layout/Layout';

function List({ children, width, pl }) {
  return (
    <Box width={width} pl={pl}>
      {children}
    </Box>
  );
}

export default List;
